import { HttpAxiosRequest } from '../../../../../http/httpAxiosBase'
import {
    CLGDetalle,
    CLGLimiteAprobado, CLGLimitesAprobadosPais,
    OperacionCLG,
    schemaCLGDetalle,
    schemaCLGLimiteAprobado, schemaListaCLGLimitesAprobadosPais,
    schemaOperacionCLG
} from '../types/types'
import { z } from 'zod'
import { BaseResponse } from '../../../../../types'
import { FormActualizarAforo } from '../components/AforoField'
import {
    OperacionCLGInsert,
    OperacionCLGUpdate,
    schemaOperacionCLGInsert,
    schemaOperacionCLGUpdate
} from '../types/dto'
import { FormInsertarEspecie } from '../types/especie'
import {HttpOperacionInforme} from "../../../api/httpOperacionInforme";
import {SistemaTipo} from "../../../../../types/enum/enum";
import {FormFiltros} from "../../../../limites/FiltrosBusqueda";

export const getEndpoint = (url = ''): string => `operaciones/clg/${url}`
export const getEndpointCache = (url = ''): string => `cache/operaciones/clg/${url}`

export const HttpCLG = {
    get: (idOperacion: number): Promise<OperacionCLG> => {
        return HttpAxiosRequest.get(getEndpoint(`${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionCLG.safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },
    put: (idOperacion: number, operacion: OperacionCLGUpdate): Promise<BaseResponse> => {
        const parsed = schemaOperacionCLGUpdate.safeParse(operacion)

        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.put(getEndpoint(`${idOperacion}`), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },
    post: (operacion: OperacionCLGInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionCLGInsert.safeParse(operacion)

        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.post(getEndpoint(), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },
    getDetalle: (codPais:number, idOperacion?: number, ): Promise<CLGDetalle[]> => {
        return HttpAxiosRequest.get(getEndpoint(`${idOperacion || -1}/detalles/${codPais}`))
            .then(response => {
                const parsed = z.array(schemaCLGDetalle).safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },
    putDetalle: (idOperacion: number, detalle: FormActualizarAforo): Promise<BaseResponse> => {
        return HttpAxiosRequest.put(getEndpoint(`${idOperacion}/detalles/${detalle.id}`), detalle)
    },
    postEspecie: (idOperacion: number, especie: FormInsertarEspecie) => {
        return HttpAxiosRequest.post(getEndpoint(`${idOperacion}/detalles`), especie)
    },
    descargarInforme: (idOperacion: number): Promise<any> =>
        HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.CLG),

    getLimites: (filtros: FormFiltros): Promise<CLGLimitesAprobadosPais[]> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(`limites`), {...filtros})
            .then(response => {
                const parsed = schemaListaCLGLimitesAprobadosPais.safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },
    
} as const
